// import echarts from "echarts";
export function loadChart(myChart, xData, yData, unit = "") {
  if (myChart) {
    myChart.clear();
  }
  if (xData.length > 0) {
    // 设置
    // var ImgIcon = require("@/assets/images/granary/nc/y-title-bg.png");
    myChart.setOption({
      grid: {
        show: false,
        borderWidth: 0,
        top: "27%",
        left: "12%",
        right: "10",
        bottom: 30,
        textStyle: {
          color: "#fff"
        }
      },
      legend: {
        top: "0%",
        right: "10%",
        show: false,
        textStyle: {
          fontSize: "20px",
          fontFamily: "MicrosoftYaHeiUI",
          color: "#FFFFFF"
        },
        itemWidth: 28,
        itemHeight: 28,
        data: [
          {
            name: "趋势",
            icon:
              "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA1UlEQVRYR+2UMQ7CMAxFvxdyFtqVhREpZ+AEnIyRM1RiY2NsOQgTXYzSUlVNm9ZWhwrJnvPjpxfHhI2LNu4PAzADZsAM/I+BT5FnAF8JqBl0cb6sNFu0z/N751+nLisy0ISJb2DkTZBQgukshYjyT+ergxhgEA6NQwUQIcQoH4HPGpgKtwZ+NhYglpq3MhM1F5ZcLDmTBJCE1wImZ0DSvAuvfaKRAU3zJIRySAczUBfZg4GjdMInIZTfNALY3wFy6xaNblGJFpFm42nPGoAZMANmwAx8ASjjyiGj/fCxAAAAAElFTkSuQmCC"
          }
        ]
      },
      xAxis: [
        {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#244a6a"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#69aada",
            fontSize: 14
          },
          data: xData
        }
      ],
      yAxis: {
        type: "value",
        name: "单位：(" + unit + ")",
        splitNumber: 4,

        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#69aada"
          }
        },
        axisLabel: {
          interval: 1,
          textStyle: {
            color: "#00c0ff",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 14
          }
        },
        splitArea: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#00c0ff"
          }
        }
      },

      series: [
        {
          name: "趋势",
          type: "line",
          symbolSize: 4,
          symbol: "circle",
          itemStyle: {
            color: "#fff",
            shadowColor: "#ff9b30",
            shadowBlur: 20,
            borderColor: "#ff9b30",
            borderWidth: 2
          },

          lineStyle: {
            width: 2,
            color: "#ff9b30",
            shadowColor: "#ff9b30",
            shadowBlur: 20
          },
          markPoint: {
            symbol: "pin", //标记(气泡)的图形
            // symbol:`image://${ImgIcon}`,
            symbolSize: 85, //标记(气泡)的大小
            itemStyle: {
              color: "#ff9b30", //图形的颜色。
              borderColor: "#ff9b30", //图形的描边颜色。支持的颜色格式同 color，不支持回调函数。
              borderWidth: 0, //描边线宽。为 0 时无描边。
              borderType: "solid", //柱条的描边类型，默认为实线，支持 ‘solid’, ‘dashed’, ‘dotted’。
              normal: {
                label: {
                  color: "#000"
                  // color: "#fff" //气泡中字体颜色
                }
              }
            },
            data: [
              {
                value: yData[0],
                xAxis: 0,
                yAxis: yData[0],
                itemStyle: { color: "#ff9b30" }
              },
              {
                value: yData[1],
                xAxis: 1,
                yAxis: yData[1],
                itemStyle: { color: "#ff9b30" }
              },
              {
                value: yData[2],
                xAxis: 2,
                yAxis: yData[2],
                itemStyle: { color: "#ff9b30" }
              },
              {
                value: yData[3],
                xAxis: 3,
                yAxis: yData[3],
                itemStyle: { color: "#ff9b30" }
              },
              {
                value: yData[4],
                xAxis: 4,
                yAxis: yData[4],
                itemStyle: { color: "#ff9b30" }
              }
            ]
          },

          data: yData
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
